//#region src/translations/es_HN.json
var es_HN_default = { "not-found": {} };
//#endregion
export { es_HN_default as default };

//# sourceMappingURL=es_HN.js.map